module.exports = __webpack_public_path__ + "static/media/IDEAS.bcf21680.png";